export const HOME: string = "/";
export const MENU: string = "/menu";
export const LOCATION: string = "/location";
export const IMPRESSUM: string = "/impressum";
